import { AMEX, DISCOVER, MA, VISA } from '../constants/partnering-networks';

/* returns the instance from orchestartion object cache
*/
const getNetworkInstance = (OrchCustomData, cardBrand) => {
  let sdkInstance = null;
  const loadedSdk = OrchCustomData?.srcSdks?.loadedSdk ?? null;
  let network = cardBrand && cardBrand.toUpperCase();
  network = cardBrand === 'MASTERCARD' ? MA : network;
  switch (network) {
    case AMEX:
      sdkInstance = loadedSdk?.AMEX ?? null;
      break;
    case DISCOVER:
      sdkInstance = loadedSdk?.DISCOVER ?? null;
      break;
    case MA:
      sdkInstance = loadedSdk?.MA ?? null;
      break;
    case VISA:
      sdkInstance = loadedSdk?.VISA ?? null;
      break;
  }
  return sdkInstance;
};

export default getNetworkInstance;
